import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../http/query-client';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {useDataTable} from '../page/data-table-context';
import {Key} from 'react';
import {Lien} from '@app/titles/models/lien';

interface Response extends BackendResponse {
  liens: Lien[];
}

export function useDownloadSelectedRows(
  selectedRows: Key[],
  enabled = false,
  token?: string,
) {
  return useQuery({
    queryKey: ['download-premium', selectedRows],
    enabled,
    queryFn: () =>
      downloadSelectedRows('download-premium', selectedRows, token),
  });
}

function downloadSelectedRows(endpoint: string, ids: Key[], token?: string) {
  return apiClient
    .post(`${endpoint}/${ids.join(',')}`, {token})
    .then(r => r.data);
}
